<template>
    <b-modal size="lg" ref="modalAssocia" id="modalAssociaUtente" title="Associa Presidio" @show="onShow()" scrollable>
        <b-form @submit.prevent="onSubmit">
            <b-row>
                <b-col xs="6" sm="6" md="12" lg="12" xl="12">
                    <b-form-input v-model="mdlFiltroUsers.donominazione" type="search" placeholder="Denominazione Utente"></b-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="sa-padding-right text-right">
                    <b-button type="submit" variant="info">Cerca</b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="6" sm="6" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Obbligatorio:</label>
                    <b-form-select v-model="obbligatorio" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                </b-col>
            </b-row>
        </b-form>
        <div class="b-table-sticky-header">
            <b-table sticky-header :busy="isBusy" ref="table" selectable stacked="lg" striped hover :items="items" :fields="fieldsModal" sort-icon-left head-variant="light" class="sa-b-table" current-page="1" :per-page="perPageUsers" @row-selected="onRowSelected">
                <template #table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Caricamento...</strong>
                    </div>
                </template>
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                        <span aria-hidden="true">&check;</span>
                        <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                        <span aria-hidden="true">&nbsp;</span>
                        <span class="sr-only">Not selected</span>
                    </template>
                </template>
                <template #cell(firstname)="row">
                    <p>{{ row.item.lastname }} {{ row.item.firstname }}</p>
                </template>
                <template v-slot:cell(checkBox)="{ item }">
                    <b-form-checkbox v-model="item.check" size="md" switch class="sa-normal-label"> </b-form-checkbox>
                </template>
                <template #cell(action)="row">
                    <b-button v-show="row.item.check" variant="outline-danger" @click="onDeleteAssociazione(row.item)">
                        <b-icon icon="person-x-fill" aria-hidden="true"></b-icon>
                        Dissocia
                    </b-button>
                </template>
            </b-table>
        </div>

        <template #modal-footer="{ ok }">
            <b-button size="sm" variant="outline-danger" @click="ok()">
                <b-icon icon="x"></b-icon>
                Annulla
            </b-button>
            <b-button size="sm" variant="outline-success" @click="onAssocia()">
                <b-icon icon="person-check-fill"></b-icon>
                Associa
            </b-button>
            <b-button size="sm" variant="outline-success" @click="onAssociaTutti()">
                <b-icon icon="person-check-fill"></b-icon>
                Associa Tutti
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    components: {},
    props: {
        associatedUsers: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        rows() {
            return this.items.length;
        },
    },
    mixins: [UtilityMixin],
    data() {
        return {
            isBusy: false,
            showModalLoading: false,
            perPage: 10,
            perPageUsers: 100000,
            currentPage: 1,
            currentPageUsers: 1,
            linkedit: null,
            obbligatorio: null,
            sinoOptions: [
                { value: null, text: "Seleziona valore", disabled: true },
                { value: "SI", text: "SI" },
                { value: "NO", text: "NO" },
            ],
            pathResource: "/strutturepresidi",
            pathResourceParametriVitaliStrutture: "/rsaparametrivitalipresidio",
            pathRESTRequest: "/ambulatorio",
            mdlFiltroUsers: {
                profilo: "",
                username: "",
            },
            selected: [],
            profiliModalOptions: [],
            filterOn: [],
            jsonData: {},
            obj: {},
            items: [],
            itemsUtenti: [],
            associazioni: [],
            filtroUsers: { forPage: 0, page: 0, user: "", profilo: "" },

            fieldsModal: [
                {
                    label: "",
                    key: "selected",
                    thStyle: "width: 2.5rem",
                    tdClass: "text-center",
                },
                {
                    label: "Codice Struttura",
                    key: "codiceStruttura",
                    sortable: true,
                },
                {
                    label: "Denominazione Struttura",
                    key: "denominazione",
                    sortable: true,
                },
                /*       {
                    label: "",
                    key: "checkBox",
                },
                {
                    label: "",
                    key: "action",
                }, */
            ],
        };
    },
    created: function () {},
    mounted: function () {},
    methods: {
        getId(obj) {
            return obj.idUtente;
        },
        init(idParametroVitale) {
            let me = this;
            me.idParametroVitale = idParametroVitale;
            me.show();
        },
        show() {
            let me = this;
            me.loadData();
            me.$refs.modalAssocia.show();
        },
        loadData() {
            let me = this;
            me.loadDataResources(me.pathResource, {}, me.resultResponseData, me.resultErrorData);
        },
        resultResponseData(response) {
            let me = this;
            me.items = [];
            me.items = response.data.data.list;
        },
        resultErrorData(error) {
            let messaggio = error.response.data.messaggio;
            console.log(messaggio);
        },

        onRowSelected(items) {
            this.selected = items;
        },
        onAssocia() {
            let me = this;
            for (let i = 0; i < me.selected.length; i++) {
                let obj = { id: null, idPresidio: me.selected[i].id, idParametroVitale: me.idParametroVitale, obbligatorio: me.obbligatorio };
                me.associaDiariPresidi(obj);
            }
        },
        onAssociaTutti() {
            let me = this;
            for (let i = 0; i < me.items.length; i++) {
                let obj = { id: null, idPresidio: me.items[i].id, idParametroVitale: me.idParametroVitale, obbligatorio: me.obbligatorio };
                me.associaDiariPresidi(obj);
            }
        },
        associaDiariPresidi(obj) {
            let me = this;
            me.saveResource(me.pathResourceParametriVitaliStrutture, obj, me.resulResponseSave, null);
        },
        resulResponseSave(response) {
            let me = this;
            me.$refs["modalAssocia"].hide();
            response.data.data;
            me.showModalLoading = false;
            me.$emit("afterSave");
            this.$bvToast.toast("Diario Associato", {
                title: this.getLabelTraduora("ambulatory.toastAssociateUserSuccess"),
                solid: true,
                variant: "success",
                autoHideDelay: 1000,
                appendToast: true,
            });
        },
        ok() {},
        onDeleteAssociazione(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm(this.getLabelTraduora("ambulatory.modelMessageConfirmDeleteAssociate"), {
                    title: this.getLabelTraduora("ambulatory.modelMessageDeleteAssociate"),
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteAssociazione(item);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        deleteAssociazione(item) {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
            axios
                .delete(link + item.id)
                .then((response) => {
                    console.log(response);
                    me.showModalLoading = false;
                    me.loadData();
                })
                .catch((error) => {
                    console.log(error);
                    me.showModalLoading = false;
                });
        },
        onShow() {
            /*   let me = this;
           ; */
        },
        onResetFiltro() {
            let me = this;
            me.filtroModal.nome = "";
            me.loadData();
        },
        onSubmit() {
            let me = this;
            me.loadData();
        },
        loadDataDiariPresidi() {
            let me = this;
            me.loadDataResources(me.pathResourceParametriVitaliStrutture, { idParametroVitale: me.idParametroVitale }, me.resultDiariPresidi, me.resultErrorDiariPresidi);
        },
        /*   resultDiariPresidi(resposne) {
            let me = this;
            me.associazioni = [];
            me.items = resposne.data.data.list;
             if (associazioni.length > 0) {
                associazioni.forEach((element) => {
                    for (let i = 0; i < me.items.length; i++) {
                        if (element.idPresidio === me.items[i].id) {
                            me.items[i].check = true;
                        }
                    }
                });
            }
            console.log(me.items);  
        },
        resultErrorDiariPresidi(error) {
            console.log(error);
        }, */
    },
};
</script>
